<script lang="ts">
    import {createEventDispatcher, onMount, tick} from "svelte";
    import CloseButtonView from "../Button/CloseButtonView.svelte";
    import {DialogViewUtil} from "./DialogViewUtil";
    import FooterType = DialogViewUtil.FooterType;

    const dispatcher = createEventDispatcher();

    export let isShow = false;
    export let title: string = '';
    export let zIndex = 0;

    let didShow = false;

    export let footerType: FooterType = FooterType.None;
    export let positiveButtonText = 'Yes';
    export let negativeButtonText = 'No';

    let contentElement: HTMLElement = null;

    onMount(() => {
    });

    $: {
        if (isShow) {
            didShow = true;

            dispatcher('show', {});

            onShowed();
        }
    }


    /**
     * 表示されて、画面描画が終わった後の処理
     */
    async function onShowed() {
        await tick();

        // 表示時の最初のフォーカスを設定
        focusFirstElement();

        dispatcher('showed', {});
    }


    function close() {
        dispatcher('close', {});
    }

    function onClickClose() {
        close();
    }

    /**
     * ダイアログ外をクリックした時
     */
    function onClickBackground() {
        if (footerType === FooterType.PositiveNegativeButton) {
            // Positive, Negative のボタンが表示される場合は、Backgroundをクリックしても close しない
            return;
        }
        close();
    }

    function onClickOk() {
        dispatcher('ok', {});
        close();
    }

    function onClickPositive() {
        dispatcher('positive', {});
    }

    function onClickNegative() {
        dispatcher('negative', {});
    }

    /**
     * 最初のエレメントにフォーカスする
     */
    function focusFirstElement() {

        // console.log({contentElement});
        if (contentElement == null) {
            return;
        }
        const firstFocusElement: HTMLElement | null = contentElement.querySelector('input:enabled, select:enabled, textarea:enabled');
        if (firstFocusElement != null) {
            firstFocusElement.focus();
        }

    }

    /**
     * キーを押した時
     * @param event
     */
    function onKeyDown(event: KeyboardEvent) {

        if (event.code === 'Escape') {
            // Escape を押した時にクローズする
            close();
        }

    }

</script>

<div class="dialog-view" class:show={isShow} on:click={onClickBackground}
     style={`z-index: ${zIndex}`}
>
    <div class="dialog-wrapper" on:click|stopPropagation on:keydown={onKeyDown}>
        <div class="dialog">
            {#if title !== ''}
                <div class="header-area with-title">
                    <div class="title-area">
                        { title }
                    </div>
                    <div class="close-button-area">
                        <CloseButtonView on:click={onClickClose}/>
                    </div>
                </div>
            {:else}
                <div class="header-area">
                    <div class="close-button-area">
                        <CloseButtonView on:click={onClickClose}/>
                    </div>
                </div>
            {/if}

            <div class="content" bind:this={contentElement}>
                {#if didShow}
                    <slot/>
                {/if}
            </div>

            {#if footerType !== FooterType.None}
                <div class="footer-area">
                    {#if footerType === FooterType.OkButton}
                        <button class="primary" on:click={onClickOk}>
                            OK
                        </button>
                    {:else if footerType === FooterType.PositiveNegativeButton}
                        <button class="primary" on:click={onClickPositive}>
                            {positiveButtonText}
                        </button>
                        <button class="primary" on:click={onClickNegative}>
                            {negativeButtonText}
                        </button>
                    {/if}
                </div>
            {/if}

        </div>
    </div>


</div>
<style lang="scss">
    .dialog-view {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #0006;


        transition-duration: 0.5s;
        opacity: 0;
        pointer-events: none;
        //z-index: var(--dialog-z-index);

        text-align: initial;

        &.show {
            opacity: 1;
            pointer-events: all;

            .dialog-wrapper {

                .dialog {
                    transform: scale(1);
                    transition-duration: 0.1s;

                    display: flex;
                    flex-direction: column;
                }
            }
        }

        .dialog-wrapper {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            overflow: hidden;

            .dialog {
                background-color: var(--background-color);

                max-width: 90vw;
                min-width: min(90vw, 500px);
                max-height: 90vh;
                border-style: solid;
                border-width: 1px;
                border-color: #aaaa;
                border-radius: 10px;
                outline: none;

                position: relative;
                transform: scale(0);
                transition-duration: 0.1s;
                transition-timing-function: linear;

                .header-area {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    font-size: 18px;


                    padding-left: 1.5em;
                    padding-right: 1.5em;
                    padding-top: 0.5em;


                    .close-button-area {
                    }

                    &.with-title {
                        border-bottom-style: solid;
                        border-bottom-width: 1px;
                        border-bottom-color: #0002;

                        padding-bottom: 0.5em;

                        .title-area {
                            flex-grow: 1;
                            padding-top: 0.5em;
                            padding-bottom: 0.5em;

                        }

                    }
                }


                > .content {
                    overflow-y: scroll;
                    //max-height: 80vh;
                    min-height: 100px;


                    padding-left: 21px;
                    padding-right: 21px;
                    padding-top: 14px;
                    padding-bottom: 14px;
                }

                .footer-area {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 24px;
                    padding-top: 12px;
                    padding-bottom: 12px;
                }


            }
        }


    }
</style>